import { useEffect, useState } from 'react';

import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';

export const useServiceWorker = (): {
  hasServiceWorker: boolean;
  serviceWorkerRegistration: ServiceWorkerRegistration;
} => {
  const [hasServiceWorker, setHasServiceWorker] = useState(false);
  const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {} as ServiceWorkerRegistration
  );

  const { enableMocks } = useRuntimeConfig();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const workerUrl = new URL('/serviceWorker.js', location.origin);
      if (enableMocks) {
        workerUrl.searchParams.set('enableApiMocking', 'true');
      }
      navigator.serviceWorker.register(workerUrl.href).then((registration) => {
        setHasServiceWorker(true);
        setServiceWorkerRegistration(registration);
      });
    }
  }, [enableMocks]);

  return { hasServiceWorker, serviceWorkerRegistration };
};
